import React, {useEffect, useState, useRef} from 'react'
import {isEmpty} from 'lodash';
import './_style.scss';
import { GatsbyImage, getImage } from "gatsby-plugin-image";

// Atoms
import HeroContent from "§/src/components/atoms/content/hero-content"

const VideoFull = (props) => {

  var {
    enableContent,
    video,
    image,
    imageMobile,
    videoMobile,
    videoVimeo,
    videoVimeoMobile,
    type,
    size,
    ...heroContentProps
  } = props.data;
  const videoUrl = video?.publicUrl;

  // set component class
  const compClassName = '';
  const compClass = props.className !== undefined ? compClassName + ' ' + props.className : compClassName;
  const heroAlignmentClass = heroContentProps.contentPosition === 'cc' ? 'align-items-center' : 'align-items-start';
  const imageMobileFallback = imageMobile || image

  useEffect(() => {

    let vimeoPlayer = document.querySelector('#vimeo-video-player');

    function playVid(vid) {
      if (vid.tagName === 'DIV') {
        vid.nextSibling.classList.add('played');
        vimeoPlayer.classList.add('visible');
      } else {
        vid.nextSibling.classList.add('played');
        vid.play();
        vid.setAttribute('controls', 'true');
      }
    }

    function pauseVid(vid) {
      if (vid.tagName === 'DIV') {
        vimeoPlayer.classList.remove('visible');
      } else {
        vid.nextSibling.classList.remove('played');
        vid.pause();
      }
    }

    // EVENT click on play layer button ----------------------
    let playLayer = document.querySelector('.video-play');
    if (playLayer) {
      document.querySelector('.video-play').addEventListener('click', function (event) {
        if (this.classList.contains('played')) {
          pauseVid(this.previousSibling)
        } else {
          playVid(this.previousSibling)
        }
      })
    }

    // EVENTS click on player controls ----------------------
    let controls = document.querySelector('video.controls-video');
    if (controls) {
      document.querySelector('video.controls-video').addEventListener('pause', (event) => {
        pauseVid(event.target)
      })
      document.querySelector('video.controls-video').addEventListener('play', (event) => {
        playVid(event.target)
      })
    }

  }, []) //notice the empty array here - Runs only on the first render


  // Lazy load video iframe
    const [visible, setVisible] = useState(false)
    const vimeoIframe = useRef(null)
    const [hasScrolled, setHasScrolled] = useState(false)

    if(!isEmpty(videoVimeo || videoVimeoMobile)){

    useEffect(() => {
      const handleScroll = () => {
        if (!hasScrolled) {
          setHasScrolled(true);
        }
      };

      window.addEventListener('scroll', handleScroll);

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // If the element is visible, change the attribute immediately
            setVisible(true);
          } else if (hasScrolled) {
            // If the user has scrolled but the element is not yet visible, change the attribute when it becomes visible
            setVisible(true);
          }
        });
      }, {
        threshold: 0.05,
      });
      observer.observe(vimeoIframe.current);

      return () => {
        window.removeEventListener('scroll', handleScroll);
        observer.disconnect();
      };
    }, [hasScrolled]);
  }


  return !isEmpty(videoUrl || videoVimeo || videoVimeoMobile) ? (

    <div comp="video-full" className={'video-full' + ' ' + type + ' size-' + size + ' ' + compClass}>

      <div className="video-full-bg">
        {image && (
          <GatsbyImage
            className="sw-image d-none d-sm-block"
            image={getImage(image)}
            objectFit="cover"
            alt={image?.altText || 'video image'}
          />
        )}

        {imageMobileFallback && (
          <GatsbyImage
            className="sw-image d-sm-none"
            image={getImage(imageMobileFallback)}
            objectFit="cover"
            fit="cover"
            alt={imageMobileFallback?.altText || 'video image'}
          />)}
      </div>

      {type === 'with-controls' && (
        videoVimeo || videoVimeoMobile ? (
          <div className="responsive-iframe">
            <iframe
              ref={vimeoIframe}
              id="vimeo-video-player"
              title="Gefran Vimeo Video"
              src={visible ? "https://player.vimeo.com/video/" + videoVimeo.split('/').pop() : ""}
              className={visible ? 'show' : 'hide'}
              width="640"
              height="360"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen/>
          </div>
        ) : (
          <video
            className="controls-video visibility-hidden"
            src={videoUrl}
            autoPlay={false}
            controls={false}>
          </video>
        )
      )}

      {type === 'bg-loop' && (
        videoVimeo || videoVimeoMobile ? (
          <div className="responsive-iframe">

            <iframe
              ref={vimeoIframe}
              id="vimeo-video-player"
              title="Gefran Vimeo Video"
              src={visible ? "https://player.vimeo.com/video/" + videoVimeo.split('/').pop() + "?h=2dd8492d0a?muted=1&background=1&autoplay=1&loop=1&byline=0&title=0" : ""}
              className={visible ? 'show' : 'hide'}
              width="640"
              height="360"
              frameBorder="0"
              muted={true}
              controls={false}
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen/>
          </div>
        ) : (
          <video
            className="bgloop-video visibility-hidden"
            src={videoUrl}
            autoPlay={true}
            muted={true}
            loop={true}
            controls={false}>
          </video>
        )
      )}


      {type === 'with-controls' && (
        videoVimeo && videoVimeoMobile ? (<></>) : (
          <div className="video-play d-none">
            <div className="play"><i></i></div>
          </div>
        )
      )}

      {(heroContentProps.pretitle || heroContentProps.title || heroContentProps.subTitle) && enableContent &&
      <HeroContent className={`hero-content ${heroAlignmentClass} justify-content-center`} data={heroContentProps}/>}

    </div>

  ) : ('');

};

export default VideoFull;
